
import { Hero } from "../components/home/Hero";
import { Vision } from "../components/home/Vision";
import { Features } from "../components/home/Features";
import { useState } from "react";
import { NewsletterForm } from "../components/home/NewsletterForm";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const Index = () => {
  const [showNewsletterForm, setShowNewsletterForm] = useState(false);

  const handleManifestClick = () => {
    const manifesteUrl = new URL('Manifeste.pdf', window.location.origin).href;
    window.open(manifesteUrl, '_blank');
  };

  const handleNewsletterButtonClick = () => {
    setShowNewsletterForm(true);
  };

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      
      {/* Newsletter Form Modal */}
      {showNewsletterForm && <NewsletterForm onSuccess={() => setShowNewsletterForm(false)} onClose={() => setShowNewsletterForm(false)} isModal={true} />}
      
      <Vision />
      <Features />
      <Footer />
    </div>
  );
};

export default Index;

